import { CheckCircle, Close, CloudUpload, Pending, Warning } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Container,
  IconButton,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { remove } from "../../../../store/uploadingFileSlice";

const NFItem = ({ item }) => {
  const dispatch = useDispatch();

  const state = useSelector((state) => state.uploading);

  const removeItem = (id) => {
    dispatch(remove(id));
  };

  const hasError = (id) => {
    return state.errors[id] !== undefined;
  };

  return (
    <>
      <Box maxWidth={true} display={"flex"} justifyContent={"space-between"}>
        <Box padding={"16px 0px 16px 16px"} gap={1}>
          <Box display={"flex"} gap={1}>
            {state.status[item.id] === "pending" && (
              <Pending fontSize="small" color="primary" />
            )}

            {state.status[item.id] === "inProgress" && (
              <CloudUpload fontSize="small" color="primary" />
            )}

            {state.status[item.id] === "completed" && hasError(item.id) && (
              <Warning fontSize="small" sx={{ color: "#E71D36" }} />
            )}

            {state.status[item.id] === "completed" && !hasError(item.id) && (
              <CheckCircle fontSize="small" sx={{ color: "#269800" }} />
            )}

            <Box>
              <Typography fontWeight="400" fontSize="14px" color={"#00010C"}>
                {item.file.name}
              </Typography>
              <Typography fontWeight="400" fontSize="14px" color={"#E71D36"}>
                {state.errors[item.id]}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
          }}
        />
        <Box minWidth={"156px"} maxWidth={"156px"} padding={2}>
          <Container sx={{ display: "flex", justifyContent: "end" }}>
            {state.status[item.id] === "pending" && (
              <IconButton
                onClick={() => {
                  removeItem(item.id);
                }}
                size="small"
                aria-label="delete"
              >
                <Close />
              </IconButton>
            )}
            {state.status[item.id] === "inProgress" && (
              <CircularProgress size="1rem" />
            )}
          </Container>

          {state.status[item.id] === "completed" && hasError(item.id) && (
            <Typography
              fontWeight="400"
              fontSize="14px"
              color={"#E71D36"}
              noWrap
            >
              Error
            </Typography>
          )}

          {state.status[item.id] === "completed" && !hasError(item.id) && (
            <Typography
              fontWeight="400"
              fontSize="14px"
              color={"#269800"}
              noWrap
            >
              Sucesso
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default NFItem;
